import type { ModalDialogProps } from '@atlaskit/modal-dialog/types';
import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { AutoFocusTargetOptions } from '../types.ts';

export const PublishModal: LoadableType<
	ModalDialogProps & {
		publishButtonDisabled?: boolean;
		closeModal: (params: { endPublishExperience: boolean }) => void;
		requestCloseModal: () => void;
		openModal: (arg: AutoFocusTargetOptions) => void;
		isUnpublishedDraft: boolean;
		openPermissionsDialog: (ContentRestrictionType: any) => void;
		userViewingPreview?: boolean;
		title: string | null;
		focusField: AutoFocusTargetOptions;
		setFocusField: React.Dispatch<React.SetStateAction<AutoFocusTargetOptions>>;
		shouldShowWorldIcon: boolean;
		shouldShowFooterButtons?: boolean;
		onHoverPublish?: () => void;
	}
> = LoadableLazy({
	loader: async () => {
		return (await import(/* webpackChunkName: "loadable-PublishModal" */ './PublishModal.tsx'))
			.PublishModal;
	},
});

export const DiscardModal: LoadableType<{
	closeModal: (params: { endPublishExperience: boolean }) => void;
	closeDiscardModal: () => void;
	isUnpublishedDraft: boolean;
}> = LoadableLazy({
	loader: async () => {
		return (await import(/* webpackChunkName: "loadable-DiscardModal" */ './DiscardModal.tsx'))
			.DiscardModal;
	},
});
export const CancelSchedulePublishModal: LoadableType<{
	closeModal: (params: { endPublishExperience: boolean }) => void;
	closeCancelModal: () => void;
	isUnpublishedDraft: boolean;
	cancelInProgress: boolean;
}> = LoadableLazy({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-CancelSchedulePublishModal" */ './CancelSchedulePublishModal.tsx'
			)
		).CancelSchedulePublishModal;
	},
});
